import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const NavUser = () => {
  const currentPath = useLocation().pathname;
  const isParkingActive = currentPath.includes('/employee/parking-lots');

  return (
    <div className="sub-navbar-bar py-2">
      <div className="container d-flex align-items-center justify-content-center gap-4 gap-md-5 flex-wrap">
        <Link
          to="/employee/parking-lots"
          className={`nav-sub-item ${isParkingActive ? 'active' : ''}`}
        >
          <i className="bi bi-p-square me-1"></i>
          <span>Các bãi phụ trách</span>
        </Link>
      </div>
    </div>
  );
};

export default NavUser;
